/* Type scale, pills and chips for the public pages — the Yunlen Business marketing register. */

export const MONO = 'yl-mono';
export const WRAP = 'relative z-10 mx-auto w-full max-w-[83.125rem] px-5 sm:px-8 lg:px-12';
export const SECTION = 'relative py-20 sm:py-28 lg:py-32';
export const EYEBROW = `${MONO} text-[0.6875rem] sm:text-xs font-medium uppercase tracking-[0.14em]`;
export const H1 =
  'text-[2.5rem] font-medium leading-[1.03] tracking-[-0.03em] text-[#171717] sm:text-[3.75rem] lg:text-[4.75rem]';
export const H2 =
  'text-[2.25rem] sm:text-[3.25rem] lg:text-[4rem] font-medium leading-[1.03] tracking-[-0.03em] text-[#171717] text-balance';
export const H3 = 'text-[1.625rem] lg:text-[2rem] font-medium leading-[1] tracking-[-0.025em] text-[#171717]';
export const CARD = 'bg-[#f5f5f5] rounded-[2rem] lg:rounded-[3.5rem]';
export const INTRO = `${MONO} text-[0.9375rem] sm:text-base leading-[1.45] text-[#565656]`;
export const BODY = 'text-[0.9375rem] leading-snug text-[#565656]';

const PILL =
  'inline-flex items-center justify-center gap-2 rounded-full border px-7 py-[1.125rem] text-[0.875rem] font-medium leading-none tracking-tight transition-colors duration-300 select-none sm:px-8 sm:py-5 sm:text-[0.9375rem]';

export const PILL_DARK = `${PILL} border-[#171717] bg-[#171717] text-[#ffffff] hover:bg-[#ffffff] hover:text-[#171717]`;
export const PILL_LIGHT = `${PILL} border-[#f5f5f5] bg-[#f5f5f5] text-[#171717] hover:border-[#171717] hover:bg-[#171717] hover:text-[#ffffff]`;
export const PILL_OUTLINE = `${PILL} border-[#171717]/15 bg-[#ffffff] text-[#171717] hover:bg-[#171717] hover:text-[#ffffff]`;

/** Uppercase mono chip, the way a card tags its fact. */
export const CHIP = `${MONO} inline-flex w-fit items-center rounded-full bg-gradient-to-br from-[#ececec] to-[#e2e2e2] px-4 py-2.5 text-[0.625rem] uppercase leading-none tracking-[0.08em] text-[#171717] lg:text-[0.6875rem]`;

export const LINK_QUIET =
  'text-[0.875rem] text-[#171717] underline decoration-[#c8c8c8] underline-offset-4 transition-opacity duration-300 hover:opacity-60';
